export default "/arb-eth.2b543c7e7003b1b97edb42631770ca08.svg";